/* eslint-disable */
import React, { HTMLProps } from 'react';

import { useTranslate } from '../../hooks';

import './modal-actions.css';

import { Button, LoadingButton } from '../buttons';

interface Props {
  isSubmitting?: boolean;
  className?: string;
  onSubmit?: () => Promise<void>;
  onCancel?: () => void;
  disabled?: boolean;
  title?: string;
  cancelButtonProps?: HTMLProps<'button'>;
  applyButtonProps?: HTMLProps<'button'>;
}

export function ModalActions({
  isSubmitting,
  className,
  onSubmit,
  onCancel,
  disabled,
  title,
  cancelButtonProps,
  applyButtonProps,
}: Props) {
  const { translate } = useTranslate();

  return (
    <div className={`modal-action-container ${className}`}>
      <Button
        className={`outline-btn global-btn ${cancelButtonProps?.className}`}
        onClick={onCancel}
      >
        {translate('Cancel')}
      </Button>
      <LoadingButton
        className={`primary-btn global-btn ${applyButtonProps?.className}`}
        isLoading={isSubmitting || false}
        onClick={onSubmit}
        disabled={disabled}
      >
        {title || translate('Submit')}
      </LoadingButton>
    </div>
  );
}
